import React, {useEffect, useState} from 'react';

import {Polyline, Marker} from './Native/MapView';
import {useSelector} from 'react-redux';

// const isEqual = (a = {}, b = {}) => {
//   var isEqualResult = 0;
//   try {
//     const aString = typeof a == 'object' ? JSON.stringify(a) : a;
//     const bString = typeof b == 'object' ? JSON.stringify(b) : b;
//     isEqualResult = aString == bString;
//   } catch (e) {}
//   return isEqualResult;
// };

const MapViewDirections = (props = {}) => {
  const [coordinates, setCoordinates] = useState(null);
  const region = useSelector((state) => state.location?.region) || {};

  var origin = `${region.latitude},${region.longitude}`;

  const [mounted, setMounted] = useState(true);

  // should use:
  // static getDerivedStateFromProps(){}
  // const UNSAFE_componentWillReceiveProps = (nextProps) => {
  //   if (
  //     (!isEqual(nextProps.origin, props.origin) ||
  //       !isEqual(nextProps.destination, props.destination) ||
  //       !isEqual(nextProps.waypoints, props.waypoints)) &&
  //     !props.preventRedraw
  //   ) {
  //     if (nextProps.resetOnChange === false) {
  //       fetchAndRenderRoute(nextProps);
  //     } else {
  //       resetState(() => {
  //         fetchAndRenderRoute(nextProps);
  //       });
  //     }
  //   }
  // };

  const resetState = () => {
    mounted && setCoordinates(null);
  };

  const decode = (t, e) => {
    for (
      var n,
        o,
        u = 0,
        l = 0,
        r = 0,
        d = [],
        h = 0,
        i = 0,
        a = null,
        c = Math?.pow(10, e || 5);
      u < t?.length;

    ) {
      (a = null), (h = 0), (i = 0);
      do (a = t.charCodeAt(u++) - 63), (i |= (31 & a) << h), (h += 5);
      while (a >= 32);
      (n = 1 & i ? ~(i >> 1) : i >> 1), (h = i = 0);
      do (a = t.charCodeAt(u++) - 63), (i |= (31 & a) << h), (h += 5);
      while (a >= 32);
      (o = 1 & i ? ~(i >> 1) : i >> 1),
        (l += n),
        (r += o),
        d?.push([l / c, r / c]);
    }

    return (d = d?.map?.(function (t) {
      return {
        latitude: t[0],
        longitude: t[1],
      };
    }));
  };

  const fetchAndRenderRoute = (props) => {
    let {
      destination,
      waypoints,
      apikey,
      onStart,
      onReady,
      onError,
      mode = 'driving',
      language = 'en',
      directionsServiceBaseUrl = 'https://maps.googleapis.com/maps/api/directions/json',
    } = props;

    if (!origin || !destination) {
      return;
    }

    if (destination.latitude && destination.longitude) {
      destination = `${destination.latitude},${destination.longitude}`;
    }

    if (!waypoints?.length) {
      waypoints = '';
    } else {
      waypoints = waypoints
        ?.map?.((waypoint) => {
          return waypoint && waypoint.latitude && waypoint.longitude
            ? `${waypoint.latitude},${waypoint.longitude}`
            : waypoint;
        })
        .join('|');
    }

    onStart &&
      onStart({
        origin,
        destination,
        waypoints: waypoints ? waypoints.split('|') : [],
      });

    // eslint-disable-next-line no-use-before-define
    fetchRoute(
      directionsServiceBaseUrl,
      origin,
      waypoints,
      destination,
      apikey,
      mode,
      language,
    )
      .then((result) => {
        if (!mounted) return;
        const {coordinates} = result;
        setCoordinates(coordinates);

        onReady && onReady(result);
      })
      .catch((errorMessage) => {
        resetState();
        console.warn(`MapViewDirections Error: ${errorMessage}`);
        onError && onError(errorMessage);
      });
  };

  useEffect(() => {
    fetchAndRenderRoute(props);

    () => {
      setMounted(false);
    };
  }, []);

  const fetchRoute = (
    directionsServiceBaseUrl,
    origin,
    waypoints,
    destination,
    apikey,
    mode,
    language,
  ) => {
    // Define the URL to call. Only add default parameters to the URL if it's a string.
    let url = directionsServiceBaseUrl;
    if (typeof directionsServiceBaseUrl === 'string') {
      url += `?origin=${origin}&waypoints=${waypoints}&destination=${destination}&key=${apikey}&mode=${mode}&language=${language}`;
    }

    return fetch(url)
      .then((response) => response.json())
      .then((json) => {
        if (json.status !== 'OK') {
          const errorMessage = json.error_message || 'Unknown error';
          return Promise.reject(errorMessage);
        }

        if (json.routes?.length) {
          const route = json.routes[0];

          return Promise.resolve({
            distance:
              route.legs.reduce((carry, curr) => {
                return carry + curr.distance.value;
              }, 0) / 1000,
            duration:
              route.legs.reduce((carry, curr) => {
                return carry + curr.duration.value;
              }, 0) / 60,
            coordinates: decode(route.overview_polyline.points),
          });
        } else {
          return Promise.reject();
        }
      });
  };

  if (!coordinates) {
    return (
      <Marker
        coordinate={{
          latitude: parseFloat(0),
          longitude: parseFloat(0),
        }}
      />
    );
  }

  return <Polyline coordinates={coordinates} {...props} />;
};

export default MapViewDirections;
